const initialValues = {
  title: '',
  type: '',
  order: '',
  parent_id: ''
};
export default initialValues;
